import { asText } from "@prismicio/helpers";
import Script from "next/script";
import React from "react";

const SchemaScript = ({ data }) => {
  const schemaText = asText(data);

  return schemaText ? (
    <Script
      id="dynamic-schema"
      type="application/ld+json"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: schemaText }}
    />
  ) : null;
};

export default SchemaScript;
